define.alias("ember-truth-helpers/helpers/eq", "calendar/helpers/eq");